import { render, staticRenderFns } from "./PublicResourceList.vue?vue&type=template&id=6a9af9fc&"
import script from "./PublicResourceList.vue?vue&type=script&lang=js&"
export * from "./PublicResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports